import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Lots_ds_lot_editorService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotId: number }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, MaterialId?: number, Notes?: string, StatusId?: number, VendorLot?: { Id?: number, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Status?: { Name?: string }, Material?: { ProjectId?: number } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.lotId)) {
      missingRequiredInParams.push('\'lotId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Lots/datasources/ds_lot_editor/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lotId: number    }) {
        if(isNil(inParams.lotId)) {
          return true; 
        }
      return false;
    }
}
